const performanceRatings = [
  "1-star",
  "2-star",
  "3-star",
  "4-star",
  "5-star",
] as const;

const performanceRatingsOptions = performanceRatings.map((el, index) => ({
  value: index.toString(),
  label: el,
}));

export default performanceRatingsOptions;
